import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HkbkplacementsListComponent } from './hkbkplacements-list/hkbkplacements-list.component';
import { HkbkplacementsCreateComponent } from './hkbkplacements-create/hkbkplacements-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HkbkplacementsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HkbkplacementsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'placementsoverview-create/:id',
        component: HkbkplacementsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HkbkplacementsRoutingModule { }
